'use strict';
import angular from 'angular';

export default class AppInfoController {
	/*@ngInject*/
	constructor($stateParams, $location, $http, $state, Application, $scope, Auth) {
		/*this.$http = $http;
		this.$state = $state;
		this.Application = Application;*/

		var vm = this;
		
		if ($stateParams.id != 'create') {
			$http.get('/api/applications/' + $stateParams.id).then(
				function(res) {
					var data = res.data;
					Application.load($stateParams.id).then(function() {
						$scope.$apply(function() {
							vm.app = Application;
						});
					});
					
				}, function(error) {
					if (error.status == "404") {
						$state.go('application_main');
					}
					console.log(error);
				});
		} else {
			Auth.getCurrentUser().then(function(user){
				if(!Auth.isAdminSync() && (user.Applications.length >= user.autorisations.maxApplicationsCount || user.autorisations.maxApplicationsCount != 'infinite')) {
					Auth.logout()
					$location.path('/login')
				}
			})
		}

		vm.submit = function (form) {
			if (form.$valid) {
				if ($stateParams.id != 'create') {
					$http.put('/api/applications/' + $stateParams.id, vm.app.general).then(
					function (res) {
						Application.save($stateParams.id);
						$state.go('application_screen_storyboard', { id: res.data._id });
					}, function (error) {
						console.log(error);
					});
				}
				else {
					vm.app.general.UserId = Auth.getCurrentUserSync()._id
					$http.post('/api/applications', vm.app.general).then(
					function (res) {
						Application.general = res.data;
						$state.go('application_screen_storyboard', { id: res.data._id });
					}, function (error) {
						console.log(error);
					});
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./client/app/application/info/info.controller.js